import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dcf83d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal-solution-content-seventh-block-wrap" }
const _hoisted_2 = { class: "terminal-solution-content-seventh-block" }

import {terminal_with_face_id, useLocalizationStore} from "@/shared";
import {BlockCardItem} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-solution-content-seventh-block',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BlockCardItem), {
        image: _unref(terminal_with_face_id),
        text: _unref(translate)('face_id_technology_text'),
        title: _unref(translate)('face_id_technology'),
        class: "terminal-solution-content-seventh-block-block-card-item second small-image big left margin-l-r"
      }, null, 8, ["image", "text", "title"])
    ])
  ]))
}
}

})